<template>
  <vs-row vs-type="flex" class="aisea-pb-6 aisea-pt-6">
    <vs-col
      vs-order="1"
      vs-type="flex"
      vs-justify="start"
      vs-align="center"
      vs-w="1"
    >
      <img
        :class="isSmallIcon ? 'small-icon' : 'large-icon'"
        :src="filterItem.iconPath"
      />
    </vs-col>
    <vs-col
      vs-order="2"
      vs-type="flex"
      vs-justify="start"
      vs-align="center"
      vs-w="7"
    >
      <span class="aisea-text-16-300-white aisea-ml-5">{{
        filterItem.name
      }}</span>
    </vs-col>
    <vs-col
      vs-order="3"
      vs-type="flex"
      vs-justify="flex-end"
      vs-align="center"
      vs-w="4"
    >
      <vs-switch
        :color="AISEA_COLOR.BLUE"
        :value="filterSwitch"
        :vs-value="true"
        @input="handleClickSwitch"
      />
    </vs-col>
  </vs-row>
</template>

<script>
/**
 * フィルターカードに表示されている項目一覧の中の一つのコンポーネント
 * @parent M.FilterCard
 * @props filterItem: Object フィルター一項目分のデータ、アイコンパス、名前、トグル状態を管理するフラグが含まれている
 * @porps isSmallIcon: Boolean 船舶種別だけアイコンサイズが異なるため、アイコンサイズのCSSを分岐させるフラグ
 * @props updateFilter: Function フィルターのvuex内のstoreとFireStoreを更新する関数
 */
import { ColorMixin } from "@/mixins";

export default {
  name: "A.FilterItem",
  mixins: [ColorMixin],
  props: {
    filterItem: {
      type: Object,
      required: true,
    },
    isSmallIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    updateFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterSwitch() {
      return this.filterItem.switchStatus;
    },
  },
  methods: {
    /** 個別のフィルターのオンオフを切り替える */
    async handleClickSwitch() {
      await this.updateFilter({
        id: String(this.filterItem.id),
        status: !this.filterSwitch,
        isAll: false,
      });
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxAutoSuggest.scss";
.small-icon {
  height: 25px;
  width: 12px;
}
.large-icon {
  height: 20px;
  width: 20px;
}
</style>
